import { getOidcAuthorizeUrl } from '@buffer-mono/shared-utils/oidcAuth'

import { navigateTo } from '~publish/helpers/navigation'

export function redirectToAuthorize(): void {
  if (typeof window === 'undefined') {
    return
  }

  if (window.location.pathname === '/embedded-compose') {
    window.parent.postMessage({ type: 'buffer|close' }, '*')
    return
  }

  navigateTo(getOidcAuthorizeUrl(window.location.href))
}
